import React, { useState } from "react";

// Custom Components
import Filter from "@Components/Filter";
import Table from "@Components/Table";

let model = [
  { id: "code", label: "Code", type: "string" },
  { id: "acronym", label: "Acronym", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "status", label: "Status", type: "string" },
  { id: "active", label: "Active", type: "boolean" },
];
const pageNumberDropdown = true;

const status = [
  {
    id: "Absent",
    name: "Absent",
  },
  {
    id: "Present",
    name: "Present",
  },
];

const active = [
  { id: "no", name: "NO" },
  { id: "yes", name: "YES" },
];

const filterFields = [
  {
    type: "reactselect",
    label: "Status",
    name: "status",
    outerOptions: status,
  },
  {
    type: "reactselect",
    label: "Active",
    name: "active",
    outerOptions: active,
  },
];

const actions = ["edit"];

export default function AttendanceType() {
  const [filterValues, setFilterValues] = useState({});
  const filterInitialValues = {
    status: "",
  };

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
      />

      <Table
        proxyURL="attendance-type/bo-list/"
        pageNumberDropdown={pageNumberDropdown}

        model={model}
        filterValues={filterValues}
        actions={actions}
        noFilter
      />
    </div>
  );
}
